<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal
      id="business-modal"
      size="lg"
      title="Business Information"
      hide-footer
    >
      <div v-show="show"
           class="alert alert-danger alert-dismissible fade show"
           role="alert">
                        <span v-for="(err, index) in validation_errors" :key="index">
                          {{ err[0] }} <br/>
                        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <label for="structure" class="col-form-label col-form-label-sm"
              >Select Structure</label
            >
            <select
              v-model="business.structure_id"
              v-validate="'required'"
              id="structure"
              name="structure"
              class="form-control form-control-sm"
            >
              <option selected value="selected" disabled
                >Select Structure Type</option
              >
              <option
                v-for="structure in structures"
                v-bind:value="structure.id"
                >StruId: {{ structure.id }} : {{ structure.stru_uses.id }} :
                {{ structure.stru_uses.desc }}</option
              >
            </select>
            <div class="invalid-feedback">
              Please Select Valid Structure
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="business_name" class="col-form-label col-form-label-sm"
              >Name of Business</label
            >
            <input
              type="text"
              v-model="business.business_name"
              v-validate="{ required: true, regex: /^[a-zA-Z\s]*$/ }"
              id="business_name"
              name="business_name"
              class="form-control form-control-sm"
              placeholder="Business Name"
            />
            <div class="invalid-feedback">Please provide Business Name</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="operator_name" class="col-form-label col-form-label-sm"
              >Business Operator Name</label
            >
            <input
              type="text"
              v-model="business.operator_name"
              v-validate="{ required: true, regex: /^[a-zA-Z\s]*$/ }"
              id="operator_name"
              name="operator_name"
              class="form-control form-control-sm"
              placeholder="Business Operator Name"
            />
            <div class="invalid-feedback">
              Please provide Business Operator Name
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="operator_father" class="col-form-label col-form-label-sm"
              >Father's Name</label
            >
            <input
              type="text"
              v-model="business.operator_father"
              v-validate="{ required: true, regex: /^[a-zA-Z\s]*$/ }"
              id="operator_father"
              name="operator_father"
              class="form-control form-control-sm"
              placeholder="Business Operator Father's Name"
            />
            <div class="invalid-feedback">
              Please provide Business Operator Fathers Name
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="operator_mother" class="col-form-label col-form-label-sm"
              >Mother's Name</label
            >
            <input
              type="text"
              v-model="business.operator_mother"
              v-validate="{ required: false, regex: /^[a-zA-Z\s]*$/ }"
              id="operator_mother"
              name="operator_mother"
              placeholder="Business Operator Mother's Name"
              class="form-control form-control-sm"
            />
            <div class="invalid-feedback">
              Please provide Business Operator Fathers Name
            </div>
          </div>
        </div>
        <div class="form-row mt-1 mb-1">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <label for="address" class="col-form-label col-form-label-sm"
              >Address of Business</label
            >
            <textarea
              type="text"
              v-model="business.address"
              v-validate="{ required: true, regex: /^[a-zA-Z\s]*$/ }"
              id="address"
              name="address"
              rows="5"
              cols="33"
              class="form-control form-control-sm"
              placeholder="Please provide details address of Business"
            ></textarea>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="business_type" class="col-form-label col-form-label-sm"
              >Type of Business</label
            >
            <input
              type="text"
              v-model="business.business_type"
              v-validate="{ required: false, regex: /^[a-zA-Z\s\,\.]*$/ }"
              id="business_type"
              name="business_type"
              class="form-control form-control-sm"
              placeholder="Business Type, eg. Book Shop"
            />
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="capital" class="col-form-label col-form-label-sm"
              >Business Capital</label
            >
            <input
              type="number"
              v-model="business.capital"
              v-validate="{ required: false, regex: /^[0-9\.]*$/ }"
              id="capital"
              name="capital"
              class="form-control form-control-sm"
              placeholder="Total capital of the Business"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="yearly_income" class="col-form-label col-form-label-sm"
            >Yearly Income</label
            >
            <input
                    type="number"
                    v-model="business.yearly_income"
                    v-validate="{ required: false, regex: /^[0-9\.]*$/ }"
                    id="yearly_income"
                    name="yearly_income"
                    class="form-control form-control-sm"
                    placeholder="Yearly Business Income"
            />
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="employees_no" class="col-form-label col-form-label-sm"
            ># of Employees</label
            >
            <input
                    type="number"
                    step="1"
                    v-model="business.employees_no"
                    name="employees_no"
                    id="employees_no"
                    v-validate="{ required: false, regex: /^[0-9]*$/ }"
                    class="form-control form-control-sm"
                    placeholder="Number of Employee"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label
              for="trade_licensing_no"
              class="col-form-label col-form-label-sm"
              >Trade Licensing no.</label
            >
            <input
              type="text"
              v-model="business.trade_licensing_no"
              v-validate="{ required: false, regex: /^[a-zA-Z0-9\s\,\.]*$/ }"
              id="trade_licensing_no"
              name="trade_licensing_no"
              class="form-control form-control-sm"
              placeholder="Trade Licensing no. (If any)"
            />
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="vat_reg_no" class="col-form-label col-form-label-sm"
              >VAT reg no.</label
            >
            <input
              type="text"
              v-model="business.vat_reg_no"
              v-validate="{ required: false, regex: /^[a-zA-Z0-9\s\,\.]*$/ }"
              id="vat_reg_no"
              name="vat_reg_no"
              class="form-control form-control-sm"
              placeholder="VAT registration no. (If Any)"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="tin_no" class="col-form-label col-form-label-sm"
              >TIN no.</label
            >
            <input
              type="text"
              v-model="business.tin_no"
              v-validate="{ required: false, regex: /^[a-zA-Z0-9\s\,\.]*$/ }"
              id="tin_no"
              name="tin_no"
              class="form-control form-control-sm"
              placeholder="TIN (If Any)"
            />
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label
              for="advance_deposite"
              class="col-form-label col-form-label-sm"
              >Deposit</label
            >
            <input
              type="number"
              v-model="business.advance_deposite"
              v-validate="{ required: false, regex: /^[0-9]*$/ }"
              id="advance_deposite"
              name="advance_deposite"
              class="form-control form-control-sm"
              placeholder="Advance for Rent"
            />
          </div>
        </div>

        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button
              variant="success"
              v-if="!this.btn_edit"
              class="form-control-sm mr-2"
              @click.prevent="save"
            >Add Business</b-button
            >
            <b-button
              variant="warning"
              v-if="this.btn_edit"
              class="form-control-sm mr-2"
              @click.prevent="update"
            >Update</b-button
            >
            <b-button
              size="sm"
              variant="danger"
              class="form-control-sm"
              @click="$bvModal.hide('business-modal')"
            >
              Cancel
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";

export default {
  name: "business",
  props: ["business", "btn_edit", "structures"],
  data() {
    return {
      businesses: [],
      validation_errors: {},
      show: false,
    };
  },

  mounted() {
    this.business.ses_id = this.$route.params.ses_id;
  },
  methods: {
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.business.ses_id = this.$route.params.ses_id; //required
          http
            .post("api/ses/businesses", this.business)
            .then(response => {
              if (!response.data.error) {
                this.$emit("resetForm");
                //this.$bvModal.hide("business-modal");
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
                this.$emit("getPersonBusinesses");
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
            });
        }
      });
    },

    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
            .put("api/ses/businesses/" + this.business.id, this.business)
            .then(response => {
              if (!response.data.error) {
                this.$bvModal.hide("business-modal");
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
                this.$emit("getPersonBusinesses");
              } else {
                this.$bvToast.toast("Update Failed", {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger"
                });
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
              this.$bvToast.toast("Update Failed", {
                title: "Error",
                autoHideDelay: 5000,
                variant: "danger"
              });
            });
        }
      });
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },
};
</script>
